export default{
    selectType:"Please select category",
    options:{
        "changePassword":'Change password'
    },
    //If you do not have a password, the initial password is 000000, you can set a new password
    changPasswordTip:''
}